
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("br2f9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $984af54bc824685d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $984af54bc824685d$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': "V\u0161echny weby",
    'navigation.global-shortcuts.apps.align': "Zarovn\xe1n\xed",
    'navigation.global-shortcuts.apps.analytics': 'Analytika',
    'navigation.global-shortcuts.apps.assets': 'Aktiva',
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': "Centrum spole\u010Dnosti",
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.focus': "Zam\u011B\u0159en\xed",
    'navigation.global-shortcuts.apps.goals': "C\xedle",
    'navigation.global-shortcuts.apps.home': "Domovsk\xe1 obrazovka",
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': 'Projekty',
    'navigation.global-shortcuts.apps.studio': 'Studio',
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': "T\xfdmy",
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': "Zav\u0159\xedt",
    'navigation.global-shortcuts.menu-expand-item.site-aria-label': 'Web {name}',
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': "(moment\xe1ln\u011B nedostupn\xe9)",
    'navigation.global-shortcuts.menu-link-item.link-external-item-label': "Ikona Otev\u0159\xedt extern\xed odkaz",
    'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': "(na\u010D\xedt\xe1n\xed)",
    'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': "(na\u010D\xedt\xe1n\xed)",
    'navigation.global-shortcuts.sites': 'Weby {productName}'
};

});


//# sourceMappingURL=cs.abcc45d2.js.map
